import React from 'react'
import ContentContainer from '../../content/ContentContainer/ContentContainer'
import ContentCover from '../../content/ContentCover/ContentCover'
import IWT from '../../iwt/IWT'

const BuyersGuideSection = ({ content }) => {
  return (
    <ContentCover>
      <ContentContainer>
        <IWT content={content} />
      </ContentContainer>
    </ContentCover>
  )
}

export default BuyersGuideSection
